import IbssTextField from '../../../../../Components/Inputs/TextField/IbssTextField';
import { appContext } from '../../../../../AppContext';
import { IbssComponent } from '../../../../../Components/Core/BaseComponent/IbssComponent';
import { QuestionInputType } from '../DataModels';

class HeaderForm extends IbssComponent<IProps, IState>
{

    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
        };
    };

    public render(): JSX.Element
    {
        return (
            <div className='m-4'>
                <IbssTextField
                    required
                    multiline={this.props.type == QuestionInputType.Header ? false : true}
                    value={this.props.value}
                    className='mb-1'
                    fullWidth
                    variant='standard'
                    label={this.props.type == QuestionInputType.Header ? this.labels.funcHeader_S : this.labels.funcSubHeader_S}
                    onChange={(e) => this.props.onValueChange(e.target.value)} />
            </div>
        )
    }
}

export default HeaderForm;

export interface IProps
{
    onValueChange: (value: string) => void;
    value: string;
    type: QuestionInputType.Header | QuestionInputType.SubHeader;
}

export interface IState
{
}